import { ChangeDetectionStrategy, Component, Input, OnChanges } from "@angular/core";
import { DecimalPipe } from "@angular/common";

import { FichaCatalogoComponent, PreciosEvaluacion } from "../ficha-catalogo/ficha-catalogo.component";
import { RadarRubrosComponent, SerieRadar } from "../radar-rubros/radar-rubros.component";
import {
  coletilla,
  conSigno,
  dictamenTexto,
  gateIcono,
  gateTexto,
  num,
  signo,
  tokensK,
  veces,
  veredictoClase,
  veredictoTexto,
} from "../homologacion-formato";
import { HomologacionFicha, HomologacionResumen } from "../../shared/model/iso42001/homologacion-modelo.model";

/**
 * El Resultado resumido de la Consulta (spec 6.6): encabezado, KPIs, gates,
 * rubros y capacidad por tarea. Sin «Qué se evaluó», sin repeticiones, sin
 * evidencia, sin procedencia y sin descarga.
 *
 * No es la pantalla la que esconde eso: HomologacionResumen no tiene dónde
 * traerlo, porque el servidor no lo manda (los endpoints de consulta no leen
 * el documento).
 *
 * Debajo del encabezado, la ficha del catálogo vigente del modelo, si quien
 * lo usa la pasa (la Consulta y la comparativa de una sola configuración):
 * informa, no califica (spec 5.8). Sus precios se comparan contra los de
 * ESTA evaluación, no contra los de la última del modelo.
 */
@Component({
  selector: "app-resultado-resumido",
  standalone: true,
  imports: [DecimalPipe, RadarRubrosComponent, FichaCatalogoComponent],
  templateUrl: "./resultado-resumido.component.html",
  styleUrls: ["../homologacion-comun.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultadoResumidoComponent implements OnChanges {
  @Input({ required: true }) resumen!: HomologacionResumen;
  /** La ficha del catálogo vigente del modelo, si la pasa quien lo usa (la Consulta). */
  @Input() ficha: HomologacionFicha | null = null;

  readonly num = num;
  readonly conSigno = conSigno;
  readonly signo = signo;
  readonly veces = veces;
  readonly tokensK = tokensK;
  readonly gateTexto = gateTexto;
  readonly gateIcono = gateIcono;
  readonly veredictoTexto = veredictoTexto;
  readonly veredictoClase = veredictoClase;
  readonly coletilla = coletilla;
  readonly dictamenTexto = dictamenTexto;

  /** Se arman una vez por resumen: el radar se redibuja cuando cambia la referencia. */
  etiquetas: string[] = [];
  series: SerieRadar[] = [];
  /** Los precios con que midió el harness esta evaluación: contra ellos se compara la ficha. */
  preciosEval: PreciosEvaluacion | null = null;

  ngOnChanges(): void {
    const e = this.resumen;
    this.preciosEval = e
      ? { idEval: e.idEval, entrada: e.precioEntradaUsd, salida: e.precioSalidaUsd, cacheLectura: e.precioCacheLecturaUsd }
      : null;
    const rubros = this.resumen?.rubros || [];
    this.etiquetas = rubros.map((r) => r.nombre);
    this.series = [{ nombre: this.resumen?.modelo || "Modelo", valores: rubros.map((r) => num(r.valor)), color: "var(--hom-serie-1)" }];
    if (!this.resumen?.esBaseline && rubros.some((r) => num(r.valorBaseline) !== null)) {
      this.series.push({
        nombre: this.resumen.baselineModelo ? `${this.resumen.baselineModelo} (baseline)` : "Baseline",
        valores: rubros.map((r) => num(r.valorBaseline)),
        color: "var(--hom-suave)",
      });
    }
  }
}
